import type { InferOutput } from 'valibot'

import type { FetchDriverUsersWithPaginationQuery } from '@/features/users/api'
import { type UsersSearchSchema } from '@/routes/_protected/$tenantKey/settings/drivers/-models'

type DriverUsersSearchDeps = InferOutput<typeof UsersSearchSchema>

export function buildFetchDriverUsersQuery(
  tenantKey: string,
  deps: DriverUsersSearchDeps
): FetchDriverUsersWithPaginationQuery {
  const { dcId, partnerId, ...rest } = deps

  return {
    tenantKey,
    query: {
      ...rest,
      dcIds: [dcId!],
      partnerIds: partnerId ? [partnerId] : undefined
    }
  }
}
